import { push } from "connected-react-router";

import * as types from "./actionTypes";
import { showModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import { toggleLoader } from "./loaderActions";
import userService from "../services/userService";
import emailService from "../services/emailService";
// import { customToast as toast } from "../utils";

export function loginUserSuccess(user) {
  return { type: types.LOGIN_USER_SUCCESS, user };
}
export function authRefreshSuccess(data) {
  return { type: types.AUTH_REFRESH_SUCCESS, data };
}
export function authRefreshFailure() {
  return { type: types.AUTH_REFRESH_FAILURE };
}

export function loadAllUsersSuccess(users) {
  return { type: types.LOAD_ALL_USERS_SUCCESS, allUsers: users };
}

export function loadUserSuccess(users) {
  return { type: types.LOAD_USER_SUCCESS, users };
}

export function getUserSuccess(user) {
  return { type: types.GET_USER_SUCCESS, user };
}

export function savingUser(status = true) {
  return { type: types.SAVING_USER, savingUser: status };
}

export function createUserSuccess(user) {
  return { type: types.CREATE_USER_SUCCESS, user };
}

export function updateUserSuccess(user) {
  return { type: types.UPDATE_USER_SUCCESS, user };
}

export function updateThemeSuccess(user) {
  return { type: types.UPDATE_THEME_SUCCESS, user };
}

export function updateFavoriteSuccess(user) {
  return { type: types.UPDATE_FAVORITES_SUCCESS, user };
}

export function deleteUserSuccess(userId) {
  return { type: types.DELETE_USER_SUCCESS, userId };
}

export function deleteAllUserSuccess(userId) {
  return { type: types.DELETE_ALL_USERS_SUCCESS, userId };
}
export function logoutUserSuccess() {
  return { type: types.LOGOUT_USER_SUCCESS };
}

// export function checkAuthSuccess(user) {
//   return { type: types.CHECK_AUTH_SUCCESS, user };
// }

export function resetPassSentSuccess(status = true) {
  return { type: types.RESET_PASS_SENT_SUCCESS, status };
}

export function resetPassSuccess(status = true) {
  return { type: types.RESET_PASS_SUCCESS, status };
}

export function getCallCountSuccess(callCount) {
  return { type: types.GET_CALL_COUNT_SUCCESS, callCount };
}

export function loadUserResourceSummarySuccess(resource_summary) {
  return { type: types.USER_RESOURCE_SUMMARY_SUCCESS, resource_summary };
}

export function requestUserId(userId) {
  return (dispatch) => {
    dispatch({ type: types.REQUEST_USER_ID, userToDelete: userId });
    dispatch(showModalSuccess("userDeleteModal"));
  };
}

export function logoutUser() {
  return (dispatch) => {
    userService.logoutUser().finally(() => {
      dispatch(logoutUserSuccess());
      dispatch(push("/login"));
    });
  };
}

export function forgotPassword(user) {
  return (dispatch) => {
    dispatch(savingUser());
    return userService
      .forgotPassword(user)
      .then(() => {
        dispatch(resetPassSentSuccess());
        dispatch(savingUser(false));

        dispatch(showAlertSuccess("Password Reset Link Sent", "success"));
        dispatch(push("/login"));
      })
      .catch((error) => {
        dispatch(savingUser(false));
        dispatch(showAlertSuccess("Could not reset password", "error"));
      });
  };
}

export function resetPassword(user) {
  return (dispatch) => {
    dispatch(savingUser());
    return userService
      .resetPassword(user)
      .then((data) => {
        dispatch(resetPassSuccess());
        dispatch(savingUser(false));
        dispatch(showAlertSuccess("Password Reset", "success"));
        dispatch(push("/login"));

        const email = {
          to: data.email,
          from: "noreply@gravoc.com",
          subject: "Reset Success",
          html: "<p><em>This is an automated email</em></p>",
          templateId: "3abb3303-c20d-4457-a969-79a512a5e1f5",
          substitutions: {
            name: data.first_name
          }
        };

        return emailService.sendEmail(email);
      })
      .then((res) => {
        // console.log("SENDGRID res", res);
      })
      .catch((error) => {
        dispatch(savingUser(false));
        dispatch(showAlertSuccess("Could not reset password", "error"));
      });
  };
}

export function authRefresh() {
  return (dispatch) => {
    userService
      .authRefresh()
      .then((authRefreshData) => {
        // Handle refresh token expiration error
        if (authRefreshData.statusCode === 500) {
          dispatch(showAlertSuccess(authRefreshData.message, "error"));
          dispatchEvent(authRefreshFailure());
          dispatch(push("/"));
        } else {
          dispatch(authRefreshSuccess(authRefreshData));
        }
      })
      .catch(() => {
        dispatch(authRefreshFailure());
        dispatch(push("/"));
      });
  };
}

export function loadAllUsers() {
  return (dispatch) =>
    userService
      .loadAllUsers()
      .then((data) => dispatch(loadAllUsersSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function loadUsers() {
  return (dispatch) => {
    dispatch(toggleLoader(true));
    userService
      .loadUsers()
      .then((data) => {
        dispatch(loadUserSuccess(data));
        dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function getUser(id, showUserDetails = false) {
  return (dispatch) =>
    userService
      .getUser(id)
      .then((user) => {
        dispatch(getUserSuccess(user));
        if (showUserDetails) {
          dispatch(showModalSuccess("userDetailsModal"));
        }
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function createUser(user) {
  return (dispatch) => {
    dispatch(savingUser());
    return userService
      .createUser(user)
      .then((createdUser) => {
        dispatch(createUserSuccess(createdUser));
        dispatch(savingUser(false));
        dispatch(showAlertSuccess("User created successfully", "success"));
        dispatch(push("/app/settings/users"));
      })
      .catch((error) => {
        dispatch(savingUser(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateUser(user, EVENT) {
  return (dispatch) => {
    dispatch(savingUser());
    return userService
      .updateUser(user)
      .then((updatedUser) => {
        switch (EVENT) {
          case "password":
            dispatch(updateUserSuccess(updatedUser));
            dispatch(
              showAlertSuccess("Password updated successfully", "success")
            );
            break;
          case "favorite":
            dispatch(updateFavoriteSuccess(updatedUser));
            dispatch(
              showAlertSuccess("Favorites successfully updated", "success")
            );
            break;
          case "account":
            dispatch(updateThemeSuccess(updatedUser));
            break;
          case "layout":
            break;
          default:
            dispatch(updateUserSuccess(updatedUser));
            dispatch(showAlertSuccess("User updated successfully", "success"));
            dispatch(push("/app/settings/users"));
            break;
        }
        dispatch(savingUser(false));
      })
      .catch(({ response }) => {
        if (EVENT === "toggle") {
          user.is_active = !user.is_active;
          dispatch(updateUserSuccess(user));
        }
        dispatch(savingUser(false));
        dispatch(showAlertSuccess(response.data.errors.message, "error"));
      });
  };
}

export function deleteUser(id) {
  return (dispatch) =>
    userService
      .deleteUser(id)
      .then(() => {
        dispatch(deleteAllUserSuccess(id));
        dispatch(showAlertSuccess("User removed successfully", "success"));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function checkCallCount(id) {
  return (dispatch) =>
    userService.checkCallCount(id).then((count) => {
      dispatch(getCallCountSuccess(count));
      if (count === 0) {
        dispatch(
          showAlertSuccess("Please log your time into GFS", "info", false)
        );
      }
    });
}

export function updateFavorites(user, projectId) {
  return () => {
    const { favorites } = user;
    const doesExist = favorites.find((id) => id === projectId);

    if (projectId === doesExist) {
      // if exists, find it by its index and call Array.splice()
      const existingProjectId = favorites.indexOf(doesExist);
      favorites.splice(existingProjectId, 1);
    } else {
      favorites.push(projectId); // if it doesn't add it to the array
    }

    user.favorites = favorites;
    this.updateUser(user, "favorite");
  };
}

export function loginUser(user) {
  return (dispatch) => {
    dispatch(savingUser());
    return userService
      .loginUser(user)
      .then((data) => {
        if (data.user) {
          dispatch(loginUserSuccess(data));
          dispatch(savingUser(false));

          dispatch(
            showAlertSuccess(
              `Welcome, ${data.user.first_name}`,
              "success",
              false
            )
          );

          // const token = localStorage.getItem("grav_token");
          // dispatch(checkAuth(token));
          if (data.user.hasChangedPassword) {
            dispatch(push("/app/dashboard"));
          } else {
            dispatch(getUser(data.user._id, true));
            dispatch(push("/app/profile"));
            dispatch(showModalSuccess("userDetailsModal"));
          }
        } else {
          dispatch(savingUser(false));
          dispatch(showAlertSuccess(data.reason, "error"));
        }
      })
      .catch((error) => {
        dispatch(showAlertSuccess("Invalid Username or Password", "error"));
        dispatch(savingUser(false));
      });
  };
}

export function loadProjectManagers() {
  return (dispatch) =>
    userService
      .loadProjectManagers()
      .then((data) => dispatch(loadUserSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function loadUserResourceSummary(userId) {
  return (dispatch) =>
    userService
      .loadUserResourceSummary(userId)
      .then((data) => dispatch(loadUserResourceSummarySuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function findByFilters(body) {
  return (dispatch) =>
    userService
      .findByFilters(body)
      .then((data) => {
        dispatch(loadAllUsersSuccess(data));
        return data;
      })
      .catch((error) =>
        dispatch(showAlertSuccess("Unable to load users.", error))
      );
}
